(ns nosco.shared.email-checker
  (:require
   [clojure.string :as string]))

;; Domain: Unicode letters/digits, hyphens, dots. TLD: 2+ Unicode letters.
;; Local part: any non-whitespace except @.
;; The regex must be cross-platform (CLJ uses java.util.regex, CLJS uses JS RegExp).
;; We use \p{L} and \p{N} for Unicode letter/digit classes.
;; In CLJS, the "u" flag is required for \p{} support.

(defn matches-email [maybe-email]
  (when (and maybe-email (string? maybe-email))
    #?(:clj  (re-matches #"[^\s@]+@[\p{L}\p{N}.\-]+\.[\p{L}]{2,}" maybe-email)
       :cljs (re-find (js/RegExp. "^[^\\s@]+@[\\p{L}\\p{N}.\\-]+\\.[\\p{L}]{2,}$" "u")
                      maybe-email))))

(defn normalize-email [email]
  (-> email
      (string/lower-case)
      (string/trim)))
